import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

interface LegalLayoutProps {
  title: string;
  lead: string;
  children: ReactNode;
}

export function LegalLayout({ title, lead, children }: LegalLayoutProps) {
  return (
    <main className="page legal">
      <article className="legal-article">
        <Link to="/" className="link-muted legal-back">← Accueil</Link>
        <h1>{title}</h1>
        <p className="legal-lead">{lead}</p>
        {children}
      </article>
    </main>
  );
}
